<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 3.01001H3C1.9 3.01001 1 3.91001 1 5.01001V15H3V9.99501V4.99001H21V19.02H3V15H1V19.01C1 20.11 1.9 20.99 3 20.99H21C22.1 20.99 23 20.11 23 19.01V5.01001C23 3.90001 22.1 3.01001 21 3.01001ZM21 3.01001H3C1.9 3.01001 1 3.91001 1 5.01001V15H3V9.99501V4.99001H21V19.02H3V15H1V19.01C1 20.11 1.9 20.99 3 20.99H21C22.1 20.99 23 20.11 23 19.01V5.01001C23 3.90001 22.1 3.01001 21 3.01001Z"
      fill="url(#paint0_linear_5364_5601)"
    />
    <path
      d="M6.48841 16V14.896H7.62841V8.728H6.48841V7.624H10.1364V8.728H8.98441V14.896H10.1364V16H6.48841ZM11.8406 7.624H14.8046C15.3406 7.624 15.8246 7.712 16.2566 7.888C16.6966 8.064 17.0686 8.328 17.3726 8.68C17.6846 9.024 17.9246 9.46 18.0926 9.988C18.2606 10.508 18.3446 11.116 18.3446 11.812C18.3446 12.508 18.2606 13.12 18.0926 13.648C17.9246 14.168 17.6846 14.604 17.3726 14.956C17.0686 15.3 16.6966 15.56 16.2566 15.736C15.8246 15.912 15.3406 16 14.8046 16H11.8406V7.624ZM14.8046 14.8C15.4286 14.8 15.9326 14.604 16.3166 14.212C16.7006 13.82 16.8926 13.244 16.8926 12.484V11.14C16.8926 10.38 16.7006 9.804 16.3166 9.412C15.9326 9.02 15.4286 8.824 14.8046 8.824H13.1966V14.8H14.8046Z"
      fill="url(#paint1_linear_5364_5601)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5364_5601"
        x1="1"
        y1="3.01001"
        x2="18.7041"
        y2="24.525"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5364_5601"
        x1="5"
        y1="8"
        x2="11.9398"
        y2="20.062"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
    </defs>
  </svg>
</template>
